<template>
  <div
    data-testid="skeleton-loader"
    class="tw-flex tw-items-center"
    :class="{ 'tw-animate-pulse': !shimmer }"
  >
    <div class="tw-flex-1 tw-py-2">
      <div
        :style="{ height, width }"
        class="tw-bg-sf-slate-lighter-1 tw-rounded"
        :class="{ 'sf-skeleton-loader__glare': shimmer }"
      ></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  height?: string
  width?: string
  shimmer?: boolean
}

withDefaults(defineProps<Props>(), {
  height: '1rem',
  width: '75%',
  shimmer: false,
})
</script>

<style lang="scss" scoped>
.sf-skeleton-loader__glare {
  position: relative;
  overflow: hidden;

  &::after {
    position: absolute;
    animation: sf-skeleton-loader-glare 1.6s ease-in-out infinite;
    background-image: linear-gradient(
      90deg,
      rgb(255 255 255 / 0%),
      rgb(255 255 255 / 65%),
      rgb(255 255 255 / 0%)
    );
    content: '';
    inset: 0;
    transform: translateX(-100%);
  }
}

@keyframes sf-skeleton-loader-glare {
  100% {
    transform: translateX(100%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .sf-skeleton-loader__glare::after {
    animation: none;
  }
}
</style>
